import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

import { highlightCards } from '../../util/insightsUtils';

import InsightWhyModal from './InsightWhyModal';
import context from './images/context.svg';
import evidence from './images/evidence-icon.svg';
import findings from './images/findings.svg';
import impact from './images/impact.svg';
import openInNewIcon from '../../assets/img/open-in-new-black.svg';

import './InsightsCard.scss';

function InsightCard({ card, onToggle, expanded }) {
  const [showWhyModal, setShowWhyModal] = useState(false);

  function handleToggle() {
    onToggle?.();
  }

  return (
    <div className={`insight-card insight-card--${card.urgency}`}>

        <div className={`insight-card__header ${expanded ? 'expanded' : 'collapsed'}`} onClick={handleToggle}
             role="button" tabIndex={0}
             onKeyDown={(e) => e.key === 'Enter' && handleToggle()}>
          <h5>{card.urgency}</h5>
        </div>
        <div className="insight-card__title" >
          <h3>{highlightCards(card.title, card.metadata.hashedMappings)}</h3>
        </div>

        {expanded && (
          <div className="insight-card__body">
            {card.summary && (
              <p className="insight-card__description">{highlightCards(card.summary, card.metadata.hashedMappings)}</p>
            )}

            {card.action && (
              <div className="insight-card__section">
                <p className="insight-card__section-heading pl-0">NEXT STEPS:</p>
                <ul className="insight-card__list--bullet">
                  {card.action.map((action) => (
                    <li key={action}>{highlightCards(action, card.metadata.hashedMappings)}</li>
                  ))}
                </ul>
              </div>
            )}

            <Button className="btn-detail" variant="outline-secondary" size="sm" onClick={() => setShowWhyModal(true)}>
              See why <img src={openInNewIcon} alt="#" />
            </Button>

            <InsightWhyModal show={showWhyModal} onHide={() => setShowWhyModal(false)} data={card} />
          </div>
        )}

    </div>
  );
}

export default InsightCard;
